import React from 'react'
import './Icon.css'

const Icon = ({ 
  name, 
  size = 'medium', 
  className = '',
  ...props 
}) => {
  const sizeMap = {
    small: '16px',
    medium: '20px',
    large: '24px',
    xlarge: '32px'
  }

  const classes = [
    'icon',
    `icon-${size}`,
    className
  ].filter(Boolean).join(' ')

  return (
    <span 
      className={classes}
      style={{ 
        width: sizeMap[size], 
        height: sizeMap[size],
        fontSize: sizeMap[size]
      }}
      {...props}
    >
      {name}
    </span>
  )
}

export default Icon
